import React from 'react'

const CheckCircleIcon: React.FC = () => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="20" fill="var(--qs-success-green-faint)" stroke="var(--qs-success-green)" strokeWidth="2" />
      <path d="M14 22L20 28L30 16" stroke="var(--qs-success-green)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default CheckCircleIcon
